// Setup wizard: a new partner owner's first screen after setting their password.
const setupWizard = {
  title: 'Company setup',
  steps: ({ companyName }) => [
    {
      target: null,
      title: `Let's set up ${companyName}`,
      body: 'This wizard takes you through everything your company needs before it goes live. Nothing is lost if you leave: each step saves on its own and you can come back any time.'
    },
    {
      target: 'wizard-stepper',
      title: 'The steps',
      body: 'Work through them in any order. The ones marked Required must be done before you can finish; the others can wait. A tick means the step is saved.',
      placement: 'bottom'
    },
    {
      target: 'wizard-step-branding',
      title: 'Branding',
      body: 'Your name, logo and colours. They appear on the portal, your website, the app, every email and every PDF, so start here.',
      placement: 'bottom'
    },
    {
      target: 'wizard-step-services',
      title: 'Services & prices',
      body: 'What customers can order and what it costs. You start with a standard catalogue; change the names, prices and vehicle classes to suit you.',
      placement: 'bottom'
    },
    {
      target: 'wizard-step-agreements',
      title: 'Agreements',
      body: 'The provider agreement every applicant accepts, your privacy policy and customer terms. Standard wording is provided; edit it and publish a version.',
      placement: 'bottom'
    },
    {
      target: 'wizard-step-payments',
      title: 'Payments',
      body: 'Connect your Stripe account to take card payments and memberships. Until then demo mode simulates every payment so you can try the whole flow.',
      placement: 'bottom'
    },
    {
      target: 'wizard-content',
      title: 'The step itself',
      body: 'Fill in the fields and press Save; the step is marked done and the next one opens. The preview on the right (on wide screens) shows what customers will see.',
      placement: 'top'
    },
    {
      target: 'wizard-nav',
      title: 'Back and Skip',
      body: 'Skip for now moves on without saving; Back returns to the previous step. The Finish step lists your addresses and goes live once the required steps are done.',
      placement: 'top'
    },
    {
      target: null,
      title: 'After Finish',
      body: 'You will be taken to your Dashboard with a welcome tour of the portal. Everything here can be changed later under Owner Console → Company setup.'
    }
  ]
};

export default setupWizard;
